import React, { useState } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import FeatherIcon from "react-native-vector-icons/Feather";

import { FILE_TYPE } from "consts";
import { Modal, Video } from "components";

import { styles } from "./styles";

export const MediaPreview = props => {
  const [fullscreen, setFullscreen] = useState(false);

  const { media, remove } = props;
  const MediaComponent = media.type === FILE_TYPE.VIDEO ? Video : Image;

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.deleteIcon} onPress={remove}>
        <FeatherIcon
          name="x"
          size={styles._icon?.fontSize}
          color={styles._icon?.color}
        />
      </TouchableOpacity>
      {media.uri ? (
        <>
          <TouchableOpacity
            activeOpacity={1}
            onPress={() => setFullscreen(true)}
          >
            <MediaComponent
              paused
              repeat
              resizeMode="cover"
              source={{ uri: media.uri || null }}
              style={styles.thumbnail}
              height={styles._thumbnail.height}
              width={styles._thumbnail.width}
            />
          </TouchableOpacity>
          <Modal visible={fullscreen}>
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => setFullscreen(false)}
            >
              <TouchableOpacity
                style={styles.deleteIcon}
                onPress={() => setFullscreen(false)}
              >
                <FeatherIcon
                  name="x"
                  size={styles._icon?.fontSize}
                  color={styles._icon?.color}
                />
              </TouchableOpacity>
              <MediaComponent
                source={{ uri: media.uri || null }}
                repeat
                resizeMode="contain"
                style={styles.fullscreen}
                height={styles._fullscreen.height}
                width={styles._fullscreen.width}
              />
            </TouchableOpacity>
          </Modal>
        </>
      ) : (
        <FileError />
      )}
    </View>
  );
};

const FileError = () => {
  return (
    <View style={[styles.thumbnail, styles.fileErrorContainer]}>
      <FeatherIcon
        name="alert-triangle"
        size={60}
        color={styles._icon?.color}
      />
      <Text style={styles.errorHeading}>Oh Snap!</Text>
      <Text style={styles.errorMessage}>
        File size too large{"\n"}Try uploading a smaller file
      </Text>
    </View>
  );
};
